export default "__VITE_ASSET__CCKFatw$__"